var _defs, _rect, _rect2, _rect3, _rect4, _path, _path2, _circle, _g, _rect5, _rect6, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictureFraming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pf-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pf-gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EAD08D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#C9A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8C6C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pf-sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D06E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#pf-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 45,
    width: 250,
    height: 220,
    fill: "url(#pf-gold)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 58,
    width: 224,
    height: 194,
    fill: "#4E3F37"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 66,
    width: 208,
    height: 178,
    fill: "url(#pf-sky)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 220 L150 150 L190 190 L230 130 L304 220 Z",
    fill: "#9E2430",
    opacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 244 L170 180 L220 220 L260 170 L304 244 Z",
    fill: "#67141D",
    opacity: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 100,
    r: 20,
    fill: "#DDB65C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EAD08D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 45,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 45,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 265,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 265,
    r: 10
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 150,
    width: 45,
    height: 60,
    fill: "url(#pf-gold)",
    transform: "rotate(8 352 180)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 157,
    width: 31,
    height: 46,
    fill: "#E7F3F2",
    transform: "rotate(8 352 180)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 300,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Picture Framing")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureFraming);
export default __webpack_public_path__ + "static/media/picture-framing.4d1fb6fe0276945084748178454c59ce.svg";
export { ForwardRef as ReactComponent };